<template>
  <div class="dialog-content-message">
    <div class="dialog-c__title" v-html="title" />
    <div class="dialog-c__message">
      <div class="dialog-c__message__data">{{ message }}</div>
      <div class="dialog-c__message__buttons" v-if="buttons">
        <button
          v-for="(button, i) in buttons"
          :class="'btn ' + (button.class || 'btn-default')"
          type="button"
          :key="i"
          v-html="button.title"
          @click.stop="click(i, $event)"
        >
          {{ button.title }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    message: {
      type: String
    },
    buttons: {
      type: Array
    }
  },
  methods: {
    click(i, event, source = "click") {
      const button = this.buttons[i];
      if (button && typeof button.handler === "function") {
        button.handler({
          i,
          event,
          source,
          parentName: this.$parent.$parent.name,
          data: button.data
        });
      } else {
        this.$modal.hide(this.$parent.$parent.name);
      }
    }
  }
};
</script>

<style lang="scss">
.dialog-content-message {
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.3);
  color: $gray-dark;
  font-size: 16px;
  background-color: $white;
  .dialog-c {
    &__title {
      font-family: $font-weight-medium;
      font-size: 20px;
      font-weight: 500;
      letter-spacing: $letter-spacing-xs;
      padding: 13px 20px 4px 20px;
      background-color: $gray-light;
      min-height: 60px;
      background-color: rgba(254, 217, 0, 0.6);
      color: $black;
      display: flex;
      i {
        margin-right: 9px;
        margin-top: 12px;
        font-size: 22px;
        @include media-breakpoint-up(md) {
          margin-right: 7px;
          margin-top: 17px;
          font-size: 32px;
        }
      }
      @include media-breakpoint-up(md) {
        padding: 13px 20px 5px 30px;
        font-size: 28px;
      }
    }
    &__message {
      padding: 20px;
      font-size: 18px;
      color: $gray-darker;
      letter-spacing: $letter-spacing-xs;
      font-family: $font-weight-normal;
      border: 1px solid $gray-light;
      border-top: none;
      @include media-breakpoint-up(md) {
        padding: 30px;
        font-size: 20px;
      }
      &__buttons {
        width: 100%;
        font-size: 16px;
        letter-spacing: $letter-spacing-md;
        font-family: $font-weight-bold;
        @include media-breakpoint-up(md) {
          display: flex;
          justify-content: space-between;
        }
        .btn {
          width: 100%;
          margin-top: 20px;
          padding: 13px 0 9px 0;
          white-space: normal;
          @include media-breakpoint-up(md) {
            margin-top: 28px;
            width: 47.4%;
          }
        }
      }
    }
  }
}
</style>
